const FLAG_KEY = 'lp_registration_attempted_at'
const TTL_MS = 30 * 60 * 1000 // 30分

export const isLpRegistrationFlagSet = (): boolean => {
    try {
        const value = localStorage.getItem(FLAG_KEY)
        if (!value) return false
        const timestamp = parseInt(value, 10)
        if (Number.isNaN(timestamp)) return false
        return Date.now() - timestamp < TTL_MS
    } catch {
        return false
    }
}

export const markLpRegistrationFlag = (): void => {
    try {
        localStorage.setItem(FLAG_KEY, Date.now().toString())
    } catch {
        
    }
}
